import { createComponent, customMap } from 'redux-form-antd';
import { InputNumber } from 'antd'

// tslint:disable-next-line:no-any
function mapFunction(mapProps: any, { input: { onChange } } : any) {
  return {
    ...mapProps,
    // tslint:disable-next-line:no-any
    onChange: (v: any) => onChange(v)
  };
}

const inputNumberFieldMap = customMap(mapFunction);

export default createComponent(InputNumber, inputNumberFieldMap);


// WEBPACK FOOTER //
// ./src/reduxFormAntd/InputNumberField.ts